import React from 'react';

import { Box, H1, Link, Text } from '@betterment/samba-react';

import signpostImage from '../images/expired_invitation_signpost.png';

const ExpiredInvitation: React.FC = () => {
  return (
    <Box
      css={{
        display: 'flex',
        minHeight: '100vh',
        flexDirection: { base: 'column', md: 'row' },
      }}
    >
      <Box
        css={{
          display: { base: 'none', md: 'flex' },
          flex: '0 0 42%',
          bg: 'colors.primitives.gold.10',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <Box
          css={{
            width: 'auto',
            height: '100%',
            maxWidth: '100%',
            '& img': {
              width: 'auto',
              height: '100%',
              maxWidth: '100%',
              objectFit: 'contain',
            },
          }}
        >
          <img src={signpostImage} alt="Signpost illustration" />
        </Box>
      </Box>

      <Box
        css={{
          flex: 1,
          position: 'relative',
          bg: 'background.surface',
        }}
      >
        <Box
          css={{
            pt: 'space.400',
            px: { base: 'space.400', md: 'space.800', lg: '120px' },
            pb: 'space.800',
          }}
        >
          <H1 css={{ mb: 'space.100' }}>This invitation has expired.</H1>
          <Text css={{ color: 'text.weak' }}>
            Please contact{' '}
            <Link href="mailto:support@bettermentadvisorsolutions.com">support@bettermentadvisorsolutions.com</Link> for
            help.
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default ExpiredInvitation;
